import { BadgeColor } from '../styles/themeColors';

export const BADGE_TEXT_MAX_LENGTH = 20;

export interface BadgeColorOption {
    label: string;
    hex: string;
}

export const BADGE_COLORS: BadgeColorOption[] = [
    { label: 'Orange', hex: BadgeColor.orange },
    { label: 'Green', hex: BadgeColor.green },
    { label: 'Blue', hex: BadgeColor.blue },
    { label: 'Gunmetal', hex: BadgeColor.gunmetal },
    { label: 'Burgundy', hex: BadgeColor.burgundy },
    { label: 'Teal', hex: BadgeColor.teal }
];

export const getBadgeColorLabel = (hex: string): string =>
    BADGE_COLORS.find(color => color.hex === hex)?.label || hex;

export const PRODUCT_BADGES_TAB_LABEL = 'Product Badges';
export const PRODUCT_BADGES_SUBTITLE =
  'Create badges that Vendors can assign to products. Badges are shared across the US and Canada.';
export const ADD_NEW_BADGE_TITLE = 'Add new badge';
export const SAVED_BADGES_TITLE = 'Saved Badges';
export const DEACTIVATED_BADGES_TITLE = 'Deactivated Badges';

export const BADGE_TEXT_LABEL = 'Badge text';
export const BADGE_COLOR_LABEL = 'Badge color';
export const BADGE_PREVIEW_LABEL = 'Preview';
export const GENERATE_PREVIEW_TEXT = 'Generate preview';
export const DEACTIVATE_TEXT = 'Deactivate';
export const DEACTIVATED_STATUS_TEXT = 'Deactivated';

export const NO_SAVED_BADGES = 'No badges have been created yet.';
export const NO_DEACTIVATED_BADGES = 'No badges have been deactivated.';

export const BADGE_TEXT_REQUIRED = 'Enter badge text.';
export const BADGE_TEXT_TOO_LONG = `Badge text cannot exceed ${BADGE_TEXT_MAX_LENGTH} characters.`;
export const BADGE_TEXT_DUPLICATE = 'A badge with this text already exists.';
export const BADGE_COLOR_REQUIRED = 'Select a badge color.';
export const BADGE_PREVIEW_REQUIRED = 'Generate a preview before saving the badge.';
export const BADGE_PREVIEW_STALE = 'Badge details changed. Generate a new preview.';

export const BADGE_LOAD_FAILURE = 'The badges could not be loaded. Please try again.';
export const BADGE_SAVE_SUCCESS = 'Badge saved successfully.';
export const BADGE_SAVE_FAILURE = 'The badge could not be saved. Please try again.';
export const BADGE_DEACTIVATE_FAILURE = 'The badge could not be deactivated. Please try again.';

export const DEACTIVATE_BADGE_TITLE = 'Deactivate badge?';
export const DEACTIVATE_BADGE_MESSAGE =
  'Deactivating this badge will prevent Vendors from assigning it to products. Products already ' +
  'using the badge will continue to display it in Seller Hub and on the website until the badge is ' +
  'removed or replaced and the product is republished. If a Vendor edits a product using this ' +
  'badge, they must remove or replace it before saving.';
export const DEACTIVATE_BADGE_CONFIRM = 'Deactivate badge';
export const DEACTIVATE_BADGE_CANCEL = 'Cancel';

export const PRODUCT_BADGE_LABEL = 'Product badge';
export const PRODUCT_BADGE_PLACEHOLDER = 'Select a badge';
export const NO_BADGE_VALUE = 'No badge';

export const BADGE_DEACTIVATED_SUFFIX = '(Deactivated)';
export const BADGE_CURRENT_SELECTION = 'Current selection';
export const PRODUCT_BADGE_INACTIVE ='This badge has been deactivated. Remove it or select another badge before saving the product.';